module.exports = __webpack_public_path__ + "112bc47f7f278d16f3a62125a73782b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/otag-install.svg
// module id = 769
// module chunks = 0